import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Sidebar from "./components/sidebar/Sidebar";
import Navbar from "./components/navbar/Navbar";
import Dashboard from "./components/pages/Dashboard";
import User from "./components/pages/User";
import HrManagement from "./components/pages/HrManagement";
import Roles from "./components/pages/Roles";
import AddRoles from "./components/pages/AddRoles";
import Doctors from "./components/pages/Doctors";
import FeesManagement from "./components/pages/FeesManagement";
import Patients from "./components/pages/Patients";
import AddPatients from "./components/pages/AddPatients";
import Expenses from "./components/pages/Expenses";
import HospitalMaintainence from "./components/pages/HospitalMaintainence";
import HospitalPurchase from "./components/pages/HospitalPurchase";
import AddHospitalPurchase from "./components/pages/AddHospitalPurchase";
import UpdateHospitalPurchase from "./components/pages/UpdateHospitalPurchase";
import MedicineMaster from "./components/pages/Pharmacy/MedicineMaster";
import PurchasePharmacy from "./components/pages/Pharmacy/PurchasePharmacy";
import SalePharmacy from "./components/pages/Pharmacy/SalePharmacy";
import StockPharmacy from "./components/pages/Pharmacy/StockPharmacy";
import SupplierPharmacy from "./components/pages/Pharmacy/SupplierPharmacy";
import ReportPharmacy from "./components/pages/Pharmacy/ReportPharmacy";
import AddPurchasePharmacy from "./components/pages/Pharmacy/AddPurchasePharmacy";
import AddSalePharmacy from "./components/pages/Pharmacy/AddSalePharmacy";
import Reports from "./components/pages/Reports";
import Hospitalbill from "./components/pages/Hospitalbill";
import SalesBill from "./components/pages/Pharmacy/Bills/SalesBill";
import Opbill from "./components/pages/Opbill";
import DischargeSummary from "./components/pages/DischargeSummary";
import Login from "./components/login/Login";
import "./App.css";
import Staff from "./components/pages/HR_Management/Staff";
import AddStaff from "./components/pages/HR_Management/AddStaff";
import UpdateStaff from "./components/pages/HR_Management/UpdateStaff";
import Holiday from "./components/pages/HR_Management/Holiday";
import Leave from "./components/pages/HR_Management/Leave";
import Attendance from "./components/pages/HR_Management/Attendance";
import Department from "./components/pages/HR_Management/Department";
import SalaryDetails from "./components/pages/HR_Management/SalaryDetails";
import AddSalaryDetails from "./components/pages/HR_Management/AddSalaryDetails";
import UpdateSalaryDetails from "./components/pages/HR_Management/UpdateSalaryDetails";
import AttendanceCalendar from "./components/pages/HR_Management/AttendanceCalendar";
import Shift from "./components/pages/HR_Management/Shift";
import Appointment from "./components/pages/Appointment";
import Doctorfees from "./components/pages/Fees_Management/Doctorfees";
import Treatment from "./components/pages/Fees_Management/Treatment";
import DynamicBilling from "./components/pages/Fees_Management/DynamicBilling";
import BillCustomization from "./components/pages/Fees_Management/BillCustomization";
import DiscountOffer from "./components/pages/Fees_Management/DiscountOffer";
import UpdatePatients from "./components/pages/UpdatePatients";
import ViewPatient from "./components/pages/ViewPatients";
import PrescriptionData from "./components/pages/Prescriptiondata";
import PurchaseOrder from "./components/pages/Pharmacy/PurchaseOrder";
import AddPurchaseOrder from "./components/pages/Pharmacy/AddPurchaseOrder";
// IN BILLING TEMPORARILY DISABLED
// import InBilling from "./components/pages/InBilling";
import OutBilling from "./components/pages/OutBilling";
// import AddInBilling from "./components/pages/AddInBilling";
// import UpdateInBilling from "./components/pages/UpdateInBilling";
import AddOutBilling from "./components/pages/AddOutBilling";
import UpdateOutBilling from "./components/pages/UpdateOutBilling";
import SalePreviewBill from "./components/pages/Pharmacy/Bills/SalePreviewBill";
import UpdateSalePharmacy from "./components/pages/Pharmacy/UpdateSalePharmacy";
import Prescription from "./components/pages/Pharmacy/Prescription";
import PatientsHistory from "./components/pages/PatientsHistory";
// import OpInBilling from "./components/pages/OpInBilling";
import UpdatePurchasePharmacy from "./components/pages/Pharmacy/UpdatePurchasePharmacy";
import UpdatePurchaseOrder from "./components/pages/Pharmacy/UpdatePurchaseOrder";
import LabManagement from "./components/pages/LabManagement";
import AddLabManagement from "./components/pages/AddLabManagement";
import UpdateLabManagement from "./components/pages/UpdateLabManagement";
import Footer from "./components/footer/Footer";
import Notification from "./components/pages/Notification";
import Prescriptionbill from "./components/pages/Pharmacy/Bills/Prescriptionbill";
import Yoga_Patients from "./components/pages/Yoga_Patients";
import Homeopathy_Patients from "./components/pages/Homeopathy_Patients";
import PatientBirthday from "./components/pages/PatientBirthday";
import Report_Attendance_View from "./components/pages/Report_Attendance_view";
import Example from "./components/pages/Example";
import Profile from "./components/pages/Profile";
import Messages from "./components/pages/Messages";
import Settings from "./components/pages/Settings";
import Chat from "./components/pages/Chat";
import FollowUpCalls from "./components/pages/FollowUp/FollowUpCalls";
import GlobalToast from "./components/common/GlobalToast";

function App() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, []);

  // Replace every native browser alert() in the application with the
  // shared toast system. Existing page logic can continue calling alert().
  useEffect(() => {
    const nativeAlert = window.alert;
    window.alert = (message) => {
      window.dispatchEvent(
        new CustomEvent("app-toast", {
          detail: { message: String(message ?? ""), type: "warning" },
        })
      );
    };

    return () => {
      window.alert = nativeAlert;
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
      if (window.innerWidth > 1024) {
        setSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    if (!isMobile) {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  const toggleMobileSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <Router>
      <GlobalToast />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/appointments/prescription-data/bill/:id"
          element={<Hospitalbill />}
        />
        <Route
          path="/prescription-data/bill/:id"
          element={<Prescriptionbill />}
        />
        <Route
          path="/pharmacy/sale-pharmacy/add-sale-pharmacy/sale-bill/:invoice_number"
          element={<SalesBill />}
        />
        <Route
          path="/pharmacy/sale-pharmacy/sale-bill/:invoice_number"
          element={<SalePreviewBill />}
        />
        {/* IN BILLING TEMPORARILY DISABLED
        <Route
          path="/billing/in-billing/add-billing/op-In-Billing/:billInvoiceNo"
          element={<OpInBilling />}
        />
        */}
        <Route
          path="/billing/out-billing/add-billing/op-bill/:billInvoiceNo"
          element={<Opbill />}
        />
        <Route path="/dischargesummary" element={<DischargeSummary />} />
        <Route
          path="/*"
          element={
            <MainApp
              sidebarCollapsed={sidebarCollapsed}
              sidebarOpen={sidebarOpen}
              isMobile={isMobile}
              toggleSidebar={toggleSidebar}
              toggleMobileSidebar={toggleMobileSidebar}
              closeSidebar={closeSidebar}
            />
          }
        />
      </Routes>
    </Router>
  );
}

function MainApp({
  sidebarCollapsed,
  sidebarOpen,
  isMobile,
  toggleSidebar,
  toggleMobileSidebar,
  closeSidebar,
}) {
  return (
    <div className="App">
      <Sidebar
        collapsed={isMobile ? false : sidebarCollapsed}
        toggleSidebar={toggleSidebar}
        isOpen={sidebarOpen}
        closeSidebar={closeSidebar}
        isMobile={isMobile}
      />
      <div
        className={`main-content ${
          !isMobile && sidebarCollapsed ? "sidebar-collapsed" : ""
        }`}
        onClick={() => isMobile && sidebarOpen && closeSidebar()}
      >
        <Navbar
          collapsed={sidebarCollapsed}
          toggleMobileSidebar={toggleMobileSidebar}
          isMobile={isMobile}
        />
        <div className="content-wrapper">
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/notifications" element={<Notification />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/chat" element={<Chat />} />
            <Route
              path="/follow-up-calls"
              element={<FollowUpCalls stage="courtesy_call" />}
            />
            <Route
              path="/follow-up-calls/follow-up-1"
              element={<FollowUpCalls stage="follow_up_1" />}
            />
            <Route
              path="/follow-up-calls/follow-up-2"
              element={<FollowUpCalls stage="follow_up_2" />}
            />
            <Route
              path="/follow-up-calls/courtesy-call"
              element={<FollowUpCalls stage="courtesy_call" />}
            />
            <Route
              path="/roles"
              element={<Roles toggleSidebar={toggleSidebar} />}
            />
            <Route path="/roles/add-roles" element={<AddRoles />} />
            <Route path="/roles/add-roles/:id" element={<AddRoles />} />
            <Route path="/users" element={<User />} />
            <Route path="/hr-management" element={<HrManagement />} />
            <Route
              path="/hr-management/staff"
              element={<Staff toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/hr-management/staff/add-staff"
              element={<AddStaff />}
            />
            <Route
              path="/hr-management/staff/update-staff/:id"
              element={<UpdateStaff />}
            />
            <Route path="/hr-management/holiday" element={<Holiday />} />
            <Route path="/hr-management/leave" element={<Leave />} />
            <Route path="/hr-management/attendance" element={<Attendance />} />
            <Route path="/hr-management/shift" element={<Shift />} />
            <Route
              path="/hr-management/attendance/attendance-calendar/:staffId"
              element={<AttendanceCalendar />}
            />
            <Route path="/hr-management/department" element={<Department />} />
            <Route
              path="/hr-management/salary-details"
              element={<SalaryDetails />}
            />
            <Route
              path="/hr-management/salary-details/add-salary-details"
              element={<AddSalaryDetails />}
            />
            <Route
              path="/hr-management/salary-details/update-salary-details/:id"
              element={<UpdateSalaryDetails />}
            />
            <Route path="/doctors" element={<Doctors />} />
            <Route path="/fees-management" element={<FeesManagement />} />
            <Route
              path="/fees-management/treatment_charges"
              element={<Treatment />}
            />
            <Route
              path="/fees-management/doctorfee_master"
              element={<Doctorfees />}
            />
            <Route
              path="/fees-management/dynamic_billing"
              element={<DynamicBilling />}
            />

                <Route
              path="/Example"
              element={<Example />}
            />
            <Route
              path="/fees-management/discount_offers"
              element={<DiscountOffer />}
            />
            <Route
              path="/fees-management/bill_customization"
              element={<BillCustomization />}
            />
            <Route path="/patients" element={<Patients />} />
            <Route path="/patients/add-patients" element={<AddPatients />} />
            {/* <Route path="/patients/add-patients" element={<AddPatients />} /> */}
            <Route
              path="/patients/update-patients"
              element={<UpdatePatients />}
            />
            <Route
              path="/patients/view/:patient_id"
              element={<ViewPatient toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/patients/history/:patient_id"
              element={<PatientsHistory />}
            />
            <Route
              path="/patients/yoga-patients"
              element={<Yoga_Patients toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/patients/homeopathy-patients"
              element={<Homeopathy_Patients toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/patients/patient-birthday"
              element={<PatientBirthday />}
            />
            {/* IN BILLING TEMPORARILY DISABLED
            <Route
              path="/billing/in-billing"
              element={<InBilling toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/billing/in-billing/add-billing"
              element={<AddInBilling />}
            />
            <Route
              path="/billing/in-billing/update-billing/:id"
              element={<UpdateInBilling />}
            />
            */}
            <Route
              path="/billing/out-billing"
              element={<OutBilling toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/billing/out-billing/add-billing"
              element={<AddOutBilling />}
            />
            <Route
              path="/billing/out-billing/update-billing/:id"
              element={<UpdateOutBilling />}
            />
            <Route path="/expenses" element={<Expenses />} />
            <Route
              path="/hospital-maintenance"
              element={<HospitalMaintainence />}
            />
            <Route path="/hospital-purchases" element={<HospitalPurchase />} />
            <Route
              path="/hospital-purchases/add-hospital-purchase"
              element={<AddHospitalPurchase />}
            />
            <Route
              path="/hospital-purchases/update-hospital-purchase/:id"
              element={<UpdateHospitalPurchase />}
            />
            <Route
              path="/pharmacy/medicine-master"
              element={<MedicineMaster />}
            />
            <Route
              path="/pharmacy/purchase-order"
              element={<PurchaseOrder toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/pharmacy/purchase-pharmacy/add-purchase-order"
              element={<AddPurchaseOrder />}
            />
            <Route
              path="/pharmacy/purchase-pharmacy/update-purchase-order/:id"
              element={<UpdatePurchaseOrder />}
            />
            <Route
              path="/pharmacy/purchase-pharmacy"
              element={<PurchasePharmacy toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/pharmacy/purchase-pharmacy/add-purchase-pharmacy"
              element={<AddPurchasePharmacy />}
            />
            <Route
              path="/pharmacy/purchase-pharmacy/update-purchase-pharmacy/:id"
              element={<UpdatePurchasePharmacy />}
            />
            <Route path="/pharmacy/prescription" element={<Prescription />} />
            <Route
              path="/pharmacy/sale-pharmacy"
              element={<SalePharmacy toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/pharmacy/sale-pharmacy/add-sale-pharmacy"
              element={<AddSalePharmacy />}
            />
            <Route
              path="/pharmacy/sale-pharmacy/update-sale-pharmacy/:id"
              element={<UpdateSalePharmacy />}
            />
            <Route
              path="/pharmacy/sale-pharmacy/add-sale-pharmacy/sale-bill"
              element={<SalesBill />}
            />
            <Route
              path="/pharmacy/stock-management"
              element={<StockPharmacy />}
            />
            <Route path="/pharmacy/supplier" element={<SupplierPharmacy />} />
            <Route path="/pharmacy/reports" element={<ReportPharmacy />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/lab-management" element={<LabManagement />} />
            <Route path="/add-lab-management" element={<AddLabManagement />} />
            <Route
              path="/update-lab-management/:id"
              element={<UpdateLabManagement />}
            />
            <Route
              path="/appointments"
              element={<Appointment toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/appointments/prescription-data/:id"
              element={<PrescriptionData />}
            />
            <Route
              path="/report/report-view-attendance/:staffId"
              element={<Report_Attendance_View />}
            />
          </Routes>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;